import axios from "axios";
import { ElNotification } from "element-plus";
import storage from "@/utils/storage";
import { useStore } from "@/store/index";
const request = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  // baseURL: "http://192.168.3.8:8001",
  timeout: 10000,
});

axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8";
// 添加请求拦截器
request.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么
    // 本地调试时可通过 localStorage.debugUrl 覆盖接口地址
    const debugUrl = localStorage.getItem("debugUrl");
    if (debugUrl !== null) {
      config.baseURL = debugUrl;
    }
    // 判断是否有token，如果有token就携带token
    const token = storage.get("token");
    token && (config.headers.Authorization = `Bearer ${token}`);
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
request.interceptors.response.use(
  function (response) {
    const store = useStore();
    const contentType = response.headers["content-type"];
    const isFile =
      contentType &&
      (contentType.includes("application/octet-stream") ||
        contentType.includes("application/force-download") ||
        contentType.includes("application/vnd") ||
        contentType.includes("application/pdf"));
    if (isFile) {
      return response;
    }
    const res = response.data;
    if (res && res.code !== 0) {
      ElNotification({
        title: "提示",
        message: res.message,
        type: "error",
        duration: 1300, // 关闭时间
      });

      if (res.code === 401) {
        // token失效
        store.clearInfo();
      }
    }
    return response;
  },
  function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);
export default request;
